import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { RolesTableBlock } from './components/RolesTableBlock';
import { RolesToolbar } from './components/RolesToolbar';
import { useRolesList } from './hooks/useRolesList';
import type { Role } from './types/rolesList.types';

export function RolesListPage() {
  const navigate = useNavigate();
  const [pendingDelete, setPendingDelete] = useState<Role | null>(null);
  const {
    roles,
    totalItems,
    stats,
    chartData,
    filters,
    currentPage,
    pageSize,
    deletingId,
    isLoading,
    setFilters,
    setCurrentPage,
    setPageSize,
    deleteRole,
  } = useRolesList();

  const confirmDelete = async () => {
    if (!pendingDelete) return;
    const success = await deleteRole(pendingDelete);
    if (success) setPendingDelete(null);
  };

  return (
    <div className="w-full flex-1 min-w-0 space-y-4">
      <RolesToolbar
        filters={filters}
        onFiltersChange={setFilters}
        onAdd={() => navigate('?tab=roles-new')}
      />
      <RolesTableBlock
        roles={roles}
        isLoading={isLoading}
        currentPage={currentPage}
        pageSize={pageSize}
        totalItems={totalItems}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
        onView={(role) => navigate(`?tab=roles-detail&id=${role.id}`)}
        onEdit={(role) => navigate(`?tab=roles-edit&id=${role.id}`)}
        onDelete={setPendingDelete}
      />
      <ConfirmDialog
        isOpen={Boolean(pendingDelete)}
        title="Xóa vai trò"
        message={`Bạn có chắc muốn xóa vai trò ${pendingDelete?.name || ''}?`}
        confirmText="Xóa"
        cancelText="Hủy"
        isDestructive
        isLoading={Boolean(deletingId)}
        onConfirm={confirmDelete}
        onClose={() => setPendingDelete(null)}
      />
    </div>
  );
}
